export default "__VITE_ASSET__CilHMdh9__"